// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epw-contact-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-success: var(--available-country);
  --epw-error: #B42318;
  --epw-max-width: 1080px;
  --epw-radius: 16px;
  --epw-band-bg: var(--surface-dark);
  --epw-shadow: 0 10px 30px var(--shadow);
}

    .epw-contact-page, .epw-contact-page * { box-sizing: border-box; }

    .epw-contact-page {
      font-family:
        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
        "Segoe UI", sans-serif;
      color: var(--epw-ink);
      background: var(--epw-white);
      line-height: 1.6;
    }

    .epw-contact-page { width: 100%; }

    .epw-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-hero {
      padding: 72px 24px 64px;
      background:
        radial-gradient(circle at 82% 18%, rgba(200,16,46,.12), transparent 30%),
        linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
      border-bottom: 1px solid var(--epw-line);
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      color: var(--epw-red);
      font-size: .8rem;
      font-weight: 800;
      letter-spacing: .12em;
      text-transform: uppercase;
    }

    .epw-hero h1 {
      margin: 0;
      max-width: 760px;
      font-size: clamp(2.3rem, 5vw, 4.2rem);
      line-height: 1.06;
      letter-spacing: -.04em;
    }

    .epw-hero p {
      max-width: 760px;
      margin: 20px 0 0;
      color: var(--epw-muted);
      font-size: clamp(1.04rem, 2vw, 1.2rem);
    }

    .epw-main {
      padding: 54px 24px 76px;
    }

    .epw-layout {
      display: grid;
      grid-template-columns: .72fr 1.28fr;
      gap: 34px;
      align-items: start;
    }

    .epw-side {
      position: sticky;
      top: 24px;
    }

    .epw-side-card {
      padding: 26px;
      border-radius: var(--epw-radius);
      background: var(--epw-band-bg);
      color: #ffffff;
    }

    .epw-side-card h2 {
      margin: 0 0 12px;
      font-size: 1.6rem;
      line-height: 1.2;
    }

    .epw-side-card p {
      margin: 0 0 18px;
      color: #d5dbe5;
    }

    .epw-side-card ul {
      margin: 0;
      padding-left: 20px;
      color: #e5e9ef;
    }

    .epw-side-card li + li {
      margin-top: 8px;
    }

    .epw-email {
      margin-top: 16px;
      color: #ffffff;
      font-weight: 700;
      word-break: break-word;
    }

    .epw-form-card {
      padding: 30px;
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      background: var(--epw-white);
      box-shadow: var(--epw-shadow);
    }

    .epw-form-card h2 {
      margin: 0 0 8px;
      font-size: 1.7rem;
      letter-spacing: -.02em;
    }

    .epw-form-card > p {
      margin: 0 0 24px;
      color: var(--epw-muted);
    }

    .epw-form-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0,1fr));
      gap: 18px;
    }

    .epw-field {
      display: flex;
      flex-direction: column;
      gap: 7px;
    }

    .epw-field-full {
      grid-column: 1 / -1;
    }

    .epw-field label {
      font-size: .92rem;
      font-weight: 750;
      color: var(--epw-ink);
    }

    .epw-required {
      color: var(--epw-red);
    }

    .epw-optional {
      color: var(--epw-muted);
      font-weight: 500;
    }

    .epw-field input,
    .epw-field select,
    .epw-field textarea {
      width: 100%;
      border: 1px solid var(--epw-line);
      border-radius: 10px;
      background: var(--epw-white);
      color: var(--epw-ink);
      font: inherit;
      outline: none;
      transition: border-color .2s ease, box-shadow .2s ease;
    }

    .epw-field input,
    .epw-field select {
      min-height: 48px;
      padding: 0 13px;
    }

    .epw-field textarea {
      min-height: 170px;
      padding: 12px 13px;
      resize: vertical;
    }

    .epw-field input:focus,
    .epw-field select:focus,
    .epw-field textarea:focus {
      border-color: var(--epw-red);
      box-shadow: 0 0 0 4px color-mix(in srgb, var(--epw-red) 15%, transparent);
    }

    .epw-help {
      font-size: .82rem;
      color: var(--epw-muted);
    }

    .epw-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-top: 22px;
      flex-wrap: wrap;
    }

    .epw-submit {
      min-height: 50px;
      border: 0;
      border-radius: 10px;
      padding: 0 20px;
      background: var(--epw-red);
      color: var(--epw-white);
      font: inherit;
      font-weight: 800;
      cursor: pointer;
      transition: background .2s ease, transform .08s ease;
    }

    .epw-submit:hover,
    .epw-submit:focus-visible {
      background: var(--epw-red-dark);
      outline: none;
    }

    .epw-submit:active {
      transform: translateY(1px);
    }

    .epw-submit:disabled {
      opacity: .65;
      cursor: not-allowed;
    }

    .epw-privacy {
      max-width: 470px;
      margin: 0;
      color: var(--epw-muted);
      font-size: .82rem;
    }

    .epw-status {
      display: none;
      margin-top: 20px;
      padding: 14px 16px;
      border-radius: 10px;
      font-size: .92rem;
    }

    .epw-status.success {
      display: block;
      background: color-mix(in srgb, var(--epw-success) 12%, var(--epw-white));
      color: var(--epw-success);
      border: 1px solid color-mix(in srgb, var(--epw-success) 40%, transparent);
    }

    .epw-status.error {
      display: block;
      background: color-mix(in srgb, var(--epw-error) 12%, var(--epw-white));
      color: var(--epw-error);
      border: 1px solid color-mix(in srgb, var(--epw-error) 40%, transparent);
    }

    .epw-preview {
      display: none;
      margin-top: 26px;
      border-top: 1px solid var(--epw-line);
      padding-top: 24px;
    }

    .epw-preview h3 {
      margin: 0 0 12px;
      font-size: 1.05rem;
    }

    .epw-preview table {
      width: 100%;
      border-collapse: collapse;
      font-size: .9rem;
    }

    .epw-preview th,
    .epw-preview td {
      border: 1px solid var(--epw-line);
      padding: 9px 10px;
      text-align: left;
      vertical-align: top;
    }

    .epw-preview th {
      width: 28%;
      background: var(--epw-soft);
      color: var(--epw-ink);
    }

    @media (max-width: 860px) {
      .epw-layout {
        grid-template-columns: 1fr;
      }

      .epw-side {
        position: static;
      }
    }

    @media (max-width: 640px) {
      .epw-hero {
        padding: 52px 20px 46px;
      }

      .epw-main {
        padding: 40px 18px 58px;
      }

      .epw-form-grid {
        grid-template-columns: 1fr;
      }

      .epw-field-full {
        grid-column: auto;
      }

      .epw-form-card,
      .epw-side-card {
        padding: 22px;
      }

      .epw-submit {
        width: 100%;
      }

      .epw-privacy {
        max-width: none;
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/ContactPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;AACzC;;IAEI,yCAAyC,sBAAsB,EAAE;;IAEjE;MACE;;8BAEwB;MACxB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA,oBAAoB,WAAW,EAAE;;IAEjC;MACE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,uBAAuB;MACvB;;yDAEmD;MACnD,wCAAwC;IAC1C;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB;MAChB,qBAAqB;MACrB,yBAAyB;IAC3B;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,sCAAsC;IACxC;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,mCAAmC;MACnC,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,SAAS;IACX;;IAEA;MACE,aAAa;MACb,gCAAgC;MAChC,8BAA8B;MAC9B,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,SAAS;MACT,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,gBAAgB;MAChB,sBAAsB;IACxB;;IAEA;MACE,aAAa;MACb,iCAAiC;MACjC,gCAAgC;MAChC,4BAA4B;MAC5B,6BAA6B;IAC/B;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;IACX;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;IACV;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,uBAAuB;MACvB,gBAAgB;IAClB;;IAEA;;;MAGE,WAAW;MACX,iCAAiC;MACjC,mBAAmB;MACnB,4BAA4B;MAC5B,qBAAqB;MACrB,aAAa;MACb,aAAa;MACb,sDAAsD;IACxD;;IAEA;;MAEE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;;;MAGE,4BAA4B;MAC5B,yEAAyE;IAC3E;;IAEA;MACE,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,SAAS;MACT,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,mBAAmB;MACnB,eAAe;MACf,0BAA0B;MAC1B,uBAAuB;MACvB,aAAa;MACb,gBAAgB;MAChB,eAAe;MACf,oDAAoD;IACtD;;IAEA;;MAEE,+BAA+B;MAC/B,aAAa;IACf;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,cAAc;MACd,wEAAwE;MACxE,yBAAyB;MACzB,yEAAyE;IAC3E;;IAEA;MACE,cAAc;MACd,sEAAsE;MACtE,uBAAuB;MACvB,uEAAuE;IACzE;;IAEA;MACE,aAAa;MACb,gBAAgB;MAChB,qCAAqC;MACrC,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;;MAEE,iCAAiC;MACjC,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,UAAU;MACV,2BAA2B;MAC3B,qBAAqB;IACvB;;IAEA;MACE;QACE,0BAA0B;MAC5B;;MAEA;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE;QACE,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;QACE,iBAAiB;MACnB;;MAEA;;QAEE,aAAa;MACf;;MAEA;QACE,WAAW;MACb;;MAEA;QACE,eAAe;MACjB;IACF","sourcesContent":[".epw-contact-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-success: var(--available-country);\n  --epw-error: #B42318;\n  --epw-max-width: 1080px;\n  --epw-radius: 16px;\n  --epw-band-bg: var(--surface-dark);\n  --epw-shadow: 0 10px 30px var(--shadow);\n}\n\n    .epw-contact-page, .epw-contact-page * { box-sizing: border-box; }\n\n    .epw-contact-page {\n      font-family:\n        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n        \"Segoe UI\", sans-serif;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      line-height: 1.6;\n    }\n\n    .epw-contact-page { width: 100%; }\n\n    .epw-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-hero {\n      padding: 72px 24px 64px;\n      background:\n        radial-gradient(circle at 82% 18%, rgba(200,16,46,.12), transparent 30%),\n        linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);\n      border-bottom: 1px solid var(--epw-line);\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      color: var(--epw-red);\n      font-size: .8rem;\n      font-weight: 800;\n      letter-spacing: .12em;\n      text-transform: uppercase;\n    }\n\n    .epw-hero h1 {\n      margin: 0;\n      max-width: 760px;\n      font-size: clamp(2.3rem, 5vw, 4.2rem);\n      line-height: 1.06;\n      letter-spacing: -.04em;\n    }\n\n    .epw-hero p {\n      max-width: 760px;\n      margin: 20px 0 0;\n      color: var(--epw-muted);\n      font-size: clamp(1.04rem, 2vw, 1.2rem);\n    }\n\n    .epw-main {\n      padding: 54px 24px 76px;\n    }\n\n    .epw-layout {\n      display: grid;\n      grid-template-columns: .72fr 1.28fr;\n      gap: 34px;\n      align-items: start;\n    }\n\n    .epw-side {\n      position: sticky;\n      top: 24px;\n    }\n\n    .epw-side-card {\n      padding: 26px;\n      border-radius: var(--epw-radius);\n      background: var(--epw-band-bg);\n      color: #ffffff;\n    }\n\n    .epw-side-card h2 {\n      margin: 0 0 12px;\n      font-size: 1.6rem;\n      line-height: 1.2;\n    }\n\n    .epw-side-card p {\n      margin: 0 0 18px;\n      color: #d5dbe5;\n    }\n\n    .epw-side-card ul {\n      margin: 0;\n      padding-left: 20px;\n      color: #e5e9ef;\n    }\n\n    .epw-side-card li + li {\n      margin-top: 8px;\n    }\n\n    .epw-email {\n      margin-top: 16px;\n      color: #ffffff;\n      font-weight: 700;\n      word-break: break-word;\n    }\n\n    .epw-form-card {\n      padding: 30px;\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      background: var(--epw-white);\n      box-shadow: var(--epw-shadow);\n    }\n\n    .epw-form-card h2 {\n      margin: 0 0 8px;\n      font-size: 1.7rem;\n      letter-spacing: -.02em;\n    }\n\n    .epw-form-card > p {\n      margin: 0 0 24px;\n      color: var(--epw-muted);\n    }\n\n    .epw-form-grid {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0,1fr));\n      gap: 18px;\n    }\n\n    .epw-field {\n      display: flex;\n      flex-direction: column;\n      gap: 7px;\n    }\n\n    .epw-field-full {\n      grid-column: 1 / -1;\n    }\n\n    .epw-field label {\n      font-size: .92rem;\n      font-weight: 750;\n      color: var(--epw-ink);\n    }\n\n    .epw-required {\n      color: var(--epw-red);\n    }\n\n    .epw-optional {\n      color: var(--epw-muted);\n      font-weight: 500;\n    }\n\n    .epw-field input,\n    .epw-field select,\n    .epw-field textarea {\n      width: 100%;\n      border: 1px solid var(--epw-line);\n      border-radius: 10px;\n      background: var(--epw-white);\n      color: var(--epw-ink);\n      font: inherit;\n      outline: none;\n      transition: border-color .2s ease, box-shadow .2s ease;\n    }\n\n    .epw-field input,\n    .epw-field select {\n      min-height: 48px;\n      padding: 0 13px;\n    }\n\n    .epw-field textarea {\n      min-height: 170px;\n      padding: 12px 13px;\n      resize: vertical;\n    }\n\n    .epw-field input:focus,\n    .epw-field select:focus,\n    .epw-field textarea:focus {\n      border-color: var(--epw-red);\n      box-shadow: 0 0 0 4px color-mix(in srgb, var(--epw-red) 15%, transparent);\n    }\n\n    .epw-help {\n      font-size: .82rem;\n      color: var(--epw-muted);\n    }\n\n    .epw-actions {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px;\n      margin-top: 22px;\n      flex-wrap: wrap;\n    }\n\n    .epw-submit {\n      min-height: 50px;\n      border: 0;\n      border-radius: 10px;\n      padding: 0 20px;\n      background: var(--epw-red);\n      color: var(--epw-white);\n      font: inherit;\n      font-weight: 800;\n      cursor: pointer;\n      transition: background .2s ease, transform .08s ease;\n    }\n\n    .epw-submit:hover,\n    .epw-submit:focus-visible {\n      background: var(--epw-red-dark);\n      outline: none;\n    }\n\n    .epw-submit:active {\n      transform: translateY(1px);\n    }\n\n    .epw-submit:disabled {\n      opacity: .65;\n      cursor: not-allowed;\n    }\n\n    .epw-privacy {\n      max-width: 470px;\n      margin: 0;\n      color: var(--epw-muted);\n      font-size: .82rem;\n    }\n\n    .epw-status {\n      display: none;\n      margin-top: 20px;\n      padding: 14px 16px;\n      border-radius: 10px;\n      font-size: .92rem;\n    }\n\n    .epw-status.success {\n      display: block;\n      background: color-mix(in srgb, var(--epw-success) 12%, var(--epw-white));\n      color: var(--epw-success);\n      border: 1px solid color-mix(in srgb, var(--epw-success) 40%, transparent);\n    }\n\n    .epw-status.error {\n      display: block;\n      background: color-mix(in srgb, var(--epw-error) 12%, var(--epw-white));\n      color: var(--epw-error);\n      border: 1px solid color-mix(in srgb, var(--epw-error) 40%, transparent);\n    }\n\n    .epw-preview {\n      display: none;\n      margin-top: 26px;\n      border-top: 1px solid var(--epw-line);\n      padding-top: 24px;\n    }\n\n    .epw-preview h3 {\n      margin: 0 0 12px;\n      font-size: 1.05rem;\n    }\n\n    .epw-preview table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: .9rem;\n    }\n\n    .epw-preview th,\n    .epw-preview td {\n      border: 1px solid var(--epw-line);\n      padding: 9px 10px;\n      text-align: left;\n      vertical-align: top;\n    }\n\n    .epw-preview th {\n      width: 28%;\n      background: var(--epw-soft);\n      color: var(--epw-ink);\n    }\n\n    @media (max-width: 860px) {\n      .epw-layout {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-side {\n        position: static;\n      }\n    }\n\n    @media (max-width: 640px) {\n      .epw-hero {\n        padding: 52px 20px 46px;\n      }\n\n      .epw-main {\n        padding: 40px 18px 58px;\n      }\n\n      .epw-form-grid {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-field-full {\n        grid-column: auto;\n      }\n\n      .epw-form-card,\n      .epw-side-card {\n        padding: 22px;\n      }\n\n      .epw-submit {\n        width: 100%;\n      }\n\n      .epw-privacy {\n        max-width: none;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
